import { FC, ReactNode } from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "./alert-dialog-base";

import { IconButton } from "../button/icon-button";

import { CloseIcon } from "../icon/close-icon";
import { DialogProps } from "@radix-ui/react-dialog";
export interface AlertComponentType extends DialogProps {
  title: string;
  description: string | ReactNode;
  cancelText?: string;
  continueText?: string;
  onCancel?: () => void;
  onContinue?: () => void;
}

export const AlertComponent: FC<AlertComponentType> = ({
  title,
  description,
  cancelText,
  continueText,
  onCancel,
  onContinue,
  ...props
}) => {
  return (
    <AlertDialog {...props}>
      <AlertDialogContent className="max-w-[390px] p-4">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-[22px] font-medium leading-7 flex justify-between items-center text-neutral-950">
            {title}
            <IconButton onClick={() => onCancel?.()} className="">
              <CloseIcon />
            </IconButton>
          </AlertDialogTitle>
          <AlertDialogDescription className="text-xs text-neutral-950 mt-4 text-left">
            {description}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="mt-10 block space-x-0 space-y-2 overflow-hidden max-w-full">
          {continueText && (
            <AlertDialogAction
              className="w-full bg-[#903] overflow-hidden"
              onClick={() => onContinue?.()}
            >
              {continueText}
            </AlertDialogAction>
          )}
          {cancelText && (
            <AlertDialogCancel
              className="w-full overflow-hidden"
              onClick={() => onCancel?.()}
            >
              {cancelText}
            </AlertDialogCancel>
          )}
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
